import axios from 'axios';
import { API_BASE_URL } from '../utills/constant';

export const addChassisNumberService = async (data) => {
  return await axios.post(`${API_BASE_URL}/new-vehicle-stock/add-chassis-number`, data);
};

export const getBulkUploadTemplateService = async () => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock/bulk-upload-template`);
};

export const bulkUploadStockService = async (formData) => {
  return await axios.post(`${API_BASE_URL}/new-vehicle-stock/bulk-upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getBulkUploadHistoryService = async (params) => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock/bulk-upload-history`, { params });
};

export const checkAvailableChassisNumberService = async (params) => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock/check-available-chassis-number`, { params });
};

export const getNewVehicleStockService = async (params) => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock`, { params });
};

export const exportNewVehicleStockService = async (params) => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock`, { 
    params: { ...params, export: 'excel' }
  });
};

export const getDeletedVinHistoryService = async (params) => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock/deleted-vin-history`, { params });
};

export const deleteVinService = async (data) => {
  return await axios.delete(`${API_BASE_URL}/new-vehicle-stock/delete-vin`, { data });
};

export const getVinDetailsByIdService = async (id) => {
  return await axios.get(`${API_BASE_URL}/new-vehicle-stock/get-vin-details-by-id/${id}`);
};

export const updateVinService = async (data) => {
  return await axios.put(`${API_BASE_URL}/new-vehicle-stock/update-vin`, data);
};

